export const SaudiRiyalLarge = ({ className, color = 'currentColor' }: { className?: string, color?: string }) => (
  <svg
    className={className}
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_7306_16575)'>
      <path
        d='M10.7886 15.0766C10.5277 15.6342 10.3552 16.2393 10.2891 16.8738L15.8119 15.7426C16.0729 15.1851 16.2453 14.5799 16.3115 13.9453L10.7886 15.0766Z'
        fill={color}
      />
      <path
        d='M15.8129 12.3547C16.0739 11.7972 16.2464 11.192 16.3125 10.5574L12.0104 11.4391V9.74419L15.8128 8.96559C16.0738 8.40812 16.2463 7.80288 16.3124 7.16831L12.0102 8.04921V1.954C11.351 2.31065 10.7656 2.78538 10.2897 3.34536V8.40172L8.56911 8.75411V1.125C7.9099 1.48152 7.32445 1.95638 6.84855 2.51636V9.10637L2.99877 9.89463C2.73779 10.4521 2.56515 11.0573 2.49893 11.6919L6.84855 10.8012V12.9356L2.18708 13.8901C1.9261 14.4475 1.75359 15.0528 1.6875 15.6873L6.56675 14.6882C6.96394 14.6086 7.30532 14.3824 7.52727 14.071L8.4221 12.7927V12.7924C8.51499 12.6602 8.56911 12.5007 8.56911 12.329V10.4488L10.2897 10.0965V13.4862L15.8128 12.3544L15.8129 12.3547Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_7306_16575'>
        <rect width='14.625' height='15.75' fill='white' transform='translate(1.6875 1.125)' />
      </clipPath>
    </defs>
  </svg>
)
